import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { apiComment } from 'app/config/axios-interceptor';
import { EntityState, createEntitySlice, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { cleanEntity } from 'app/shared/util/entity-utils';

const initialState: EntityState<any> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: {},
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/banCnComment';

// Actions
export const getComment = createAsyncThunk(
  'comment/fetch_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/topic/${id}`;
    return apiComment.get<any>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const getReplyComment = createAsyncThunk(
  'comment/fetch_reply_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/childs/${id}`;
    return apiComment.get<any>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const createComment = createAsyncThunk(
  'comment/create_entity',
  async (entity: any, thunkAPI) => {
    const result = await apiComment.post<any>(apiUrl, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError },
);

export const replyComment = createAsyncThunk(
  'comment/create_entity',
  async (entity: any, thunkAPI) => {
    const result = await apiComment.post<any>(`${apiUrl}/reply`, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError },
);
// slice

export const CommentsSlice = createEntitySlice({
  name: 'comments',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getComment.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = action.payload.data;
      })
      .addMatcher(isFulfilled(createComment), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
      })
      .addMatcher(isPending(getComment), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(createComment), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = CommentsSlice.actions;

// Reducer
export default CommentsSlice.reducer;
